export default __webpack_public_path__ + "static/media/Pharma.7b94219e.svg";